import Loader from "react-loader-spinner";

function RequestOtp({ handleRequestOtp, isRequestingOTP }) {
  return (
    <>
      <div className="col-12">
        {isRequestingOTP ? (
          <button
            className="btn w-100 btn-primary my-4"
            onClick={handleRequestOtp}
          >
            <Loader type="Oval" color="#fff" width={20} height={20} />
          </button>
        ) : (
          <button
            className="btn w-100 btn-primary my-4"
            type="submit"
            onClick={handleRequestOtp}
          >
            Request OTP
          </button>
        )}
      </div>
    </>
  );
}

export default RequestOtp;
